/**
 * Resolve which sidebar item a route belongs to.
 *
 * The layout derived the active item by replacing the slashes in the full
 * path, so '/tenants/<uuid>' became 'tenants-<uuid>', which matched no nav
 * item: on every detail route the sidebar collapsed the parent group and
 * highlighted nothing. The active item is now the nav entry whose path is the
 * longest segment-aligned prefix of the current path, so '/tenants/<uuid>'
 * resolves to 'tenants', '/ucc/filings/<id>' to 'ucc-filings' (not
 * 'ucc-dashboard'), and '/integrations/attom' to 'integrations'.
 *
 * '/' matches only itself; otherwise every unmapped route would light the
 * Dashboard. A route with no nav entry (for example /preferences) resolves to
 * the empty string, which RoleBasedNav reads as "no active item".
 */
export function resolveActiveNavItemId(
  pathname: string,
  navIdToPath: Readonly<Record<string, string>>,
): string {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  let bestId = '';
  let bestLength = -1;
  for (const [id, navPath] of Object.entries(navIdToPath)) {
    const matches =
      navPath === '/'
        ? path === '/'
        : path === navPath || path.startsWith(`${navPath}/`);
    if (matches && navPath.length > bestLength) {
      bestId = id;
      bestLength = navPath.length;
    }
  }
  return bestId;
}
